export class EmpresaModel {
    constructor() {
        this.Sucesso = false;
    }

    public Sucesso: boolean;
    public Mensagem: string;

    public Codigo: number;
    public Nome: string;
    public Telefone: string;
    public Whatsapp: string;
    public Mensagem1: string;
    public Mensagem2: string;

    public PermiteItemEsgotado: boolean;
    public ExibeGrupoProdutos: boolean;

    public RedesSociaisEmail: string;
    public RedesSociaisFacebook: string;
    public RedesSociaisInstagram: string;
    public RedesSociaisSite: string;
    public RedesSociaisTelefone: string;
    public RedesSociaisWhatsapp: string;

    public PathImagem: string;
    public PathImagemFundo: string;
    public CodigoCor: number;

    public Cor: string;
    public CorTexto: string;
}
